







import { Component, Prop, Vue } from 'vue-property-decorator';
import CheckboxValue from '@/baklava/CheckboxValue';

@Component({})
export default class CheckboxInput extends Vue {
  @Prop({ required: true }) checked!: CheckboxValue;

  private checkboxValue = CheckboxValue;

  created() {
    if (this.checked === null) {
      this.$emit('value-change', CheckboxValue.CHECKED);
    }
  }

  private clicked() {
    const newValue: CheckboxValue = this.checked === CheckboxValue.UNCHECKED
      ? CheckboxValue.CHECKED : CheckboxValue.UNCHECKED;
    this.$emit('value-change', newValue);
  }
}
